﻿import React, { useState, useEffect } from 'react';
import { NoteObject } from '../../models/note-object';
//import { NoteType } from '../models/enums';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import HtmlEditor from 'devextreme-react/html-editor';

//import { Popup as DialogPopup } from 'devextreme-react/popup';
//import { Button } from 'devextreme-react/button';

export interface Props {
    methodId?: string;
    height?: string;
}

export default function MethodHtmlDescriptionComponent(props: Props) {
    const [note, setNote] =
        useState<NoteObject>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getMethodHtmlDescription();
    }, [props.methodId]);

    return (
        <div>
            <div id="methodHtmlDescriptionContainer" className="pw-form-unit">
                <HtmlEditor height={props.height ? props.height : "100%"} readOnly={true}
                    value={note && note.text ? note.text : undefined} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
            

        </div>
    );

    // get functions

    async function getMethodHtmlDescription() {
        if (!props.methodId)
            return;

        await CrudFunctions.getData(`methods/methodhtmldescription/${props.methodId}`)
            .then((data) => {

                console.log("HTML Desc");
                console.log(data);

                if (data) {
                    let returnedNotes = data as NoteObject;

                    if (returnedNotes) {
                        let text = atob(returnedNotes.base64Blob);

                        //hacky but gets rid of the oddball character that gets tacked on to the micron:
                        returnedNotes.text = text.replace('Â', ''); 
                        //there may be others...
                        //U +00B5

                        setNote(returnedNotes);
                    }
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Method Description");
            });

    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
